import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('characteristics', storeModule.createStoreModule('characteristics'))
